import { useCallback, useEffect } from 'react';

const useOnEsc = (onEsc: VoidFunction) => {
    const handleOnEsc = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onEsc();
            }
        },
        [onEsc]
    );

    useEffect(() => {
        document.body.addEventListener('keydown', handleOnEsc);
        return () => {
            document.body.removeEventListener('keydown', handleOnEsc);
        };
    }, [handleOnEsc]);
};

export default useOnEsc;
